//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import SearchBox from "@/components/common/search.comp.vue";
export default {
  name: "LayoutDefault",
  computed: {
    ...mapGetters(["leftDrawerOpen"])
  },
  components: {
    SearchBox
  }
};
